module.exports = __webpack_public_path__ + "img/k12_feature4.d2cc1125.png";